import { defineComponent as _defineComponent } from 'vue'
import HiddenHorizontalScrollbar from '@/components/HiddenHorizontalScrollbar.vue';
import ArticlePreview from '@/features/editorial/components/ArticlePreview.vue';

import { useArticles } from '@/features/editorial/composables/useArticles';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrendingArticles',
  props: {
    articleId: null
  },
  setup(__props: any) {

const props = __props as {
	articleId: number | null;
};



const { articles } = useArticles({
	articleId: props.articleId,
	sortByTrending: true,
});

return { __sfc: true,props, articles, HiddenHorizontalScrollbar, ArticlePreview }
}

})